//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('projectInvoicing', {
//        templateUrl: 'views/components/views/projectInvoicing/projectInvoicing.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'rememberService', 'modalService', 'projectInvoicingService', 'ttGridFactory', function ($stateParams, stateService, utilityService, translateService, rememberService, modalService, projectInvoicingService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let projectKeyno = $stateParams.project_keyno;
//            let invoiceCustNo = $stateParams.invoice_cust_no;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                projectKeynoAndNameButtons: [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('projectmenu', { project_keyno: vm.model.menu.project_keyno }) }],
//                custNoAndNameButtons: [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('customersmenu', { cust_no: vm.model.menu.invoice_cust_no }) }],
//                bgProjectInvoicingMain: {
//                    buttons: [
//                        { id: 'SELECT', label: 'bg_projectinvoicing_main_select', color: 'primary', onClick: function () { vm.model.menu.selected_tab = 'SELECT'; } },
//                        { id: 'SHOW', label: 'bg_projectinvoicing_main_show', color: 'primary', onClick: function () { vm.model.menu.selected_tab = 'SHOW'; vm.saveChanges(); } },
//                        { id: 'INVOICED', label: 'bg_projectinvoicing_main_invoiced', color: 'primary', onClick: function () { vm.model.menu.selected_tab = 'INVOICED' } }
//                    ]
//                },
//                menu: {},
//                lockedSave: false,
//                creatingInvoice: false,
//                settingNot: false
//            };

//            async function loadGrid() {
//                vm.grid = new ttGridFactory({
//                    rememberId: vm.model.menu.view_id,
//                    kendo: {
//                        height: '100%',
//                        sortable: true,
//                        aggregate: true,
//                        pager: false,
//                        selectable: 'multiple, row',
//                        filterable: false
//                    }
//                })
//                    .setLoadDataFunction({
//                        method: vm.model.menu.p2_datatask_keyno,
//                        parameters: () => vm.model.menu
//                    })
//                    .setToolbar({ wrapping: true });
//            }

//            async function loadGridBase() {
//                vm.gridBase = new ttGridFactory({
//                    rememberId: vm.model.menu.view_id_base,
//                    kendo: {
//                        height: '100%',
//                        sortable: true,
//                        aggregate: true,
//                        pager: false,
//                        selectable: 'multiple, row',
//                        filterable: false
//                    }
//                })
//                    .setLoadDataFunction({
//                        method: vm.model.menu.p2_datatask_keyno_base,
//                        parameters: () => vm.model.menu
//                    })
//                    .setToolbar({ wrapping: true });
//            }

//            async function loadGridInvoiced() {
//                vm.gridInvoiced = new ttGridFactory({ rememberId: vm.model.menu.view_id_invoiced })
//                    .setLoadDataFunction({
//                        method: vm.model.menu.p2_datatask_keyno_invoiced,
//                        parameters: () => vm.model.menu
//                    })
//                    .setToolbar({ wrapping: true })
//                    .setKendoConfig({
//                        aggregate: true,
//                        height: '100%'
//                    });
//            }

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await projectInvoicingService.getProjectInvoicing({
//                    project_keyno: projectKeyno,
//                    invoice_cust_no: invoiceCustNo
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                let allData = vm.grid.gridfunc.getAllRows().map(function (a) { return { "powtime_keyno": a.powtime_keyno, "is_selected": a.is_selected }; });
//                let mergeObj = vm.model.menu;
//                mergeObj.records = allData;

//                projectInvoicingService.saveObj(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        loadGridBase();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON CREATE PROCEDURE FUNCTION CALL

//            vm.create = function () {
//                vm.model.creatingInvoice = true;

//                let allData = vm.grid.gridfunc.getAllRows().map(function (a) { return { "powtime_keyno": a.powtime_keyno, "is_selected": a.is_selected }; });
//                let mergeObj = vm.model.menu;
//                mergeObj.records = allData;

//                projectInvoicingService.createInvoice(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.creatingInvoice = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.creatingInvoice = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON CREATE PROCEDURE FUNCTION CALL

//            // #region BUTTON SET NOT PROCEDURE FUNCTION CALL

//            vm.setNot = function () {
//                vm.model.settingNot = true;

//                let allData = vm.grid.gridfunc.getAllRows().map(function (a) { return { "powtime_keyno": a.powtime_keyno, "is_selected": a.is_selected }; });
//                let mergeObj = vm.model.menu;
//                mergeObj.records = allData;

//                projectInvoicingService.setNotInvoice(mergeObj).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.settingNot = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.settingNot = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SET NOT PROCEDURE FUNCTION CALL

//            // #region ON TAB CHANGED FUNCTION

//            vm.onTabChanged = function (value) {
//                if (!!value) {
//                    vm.model.menu.selected_tab = value;

//                    rememberService.remember('w_projectinvoicing.tab', vm.model.menu.selected_tab);
//                }
//            }

//            // #endregion ON TAB CHANGED FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadMenu();
//                loadGrid();
//                loadGridBase();
//                loadGridInvoiced();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
